<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-eye`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.97 37c6.476 0 12.47-4.12 18.03-13.026C36.584 15.099 30.602 11 23.97 11 17.34 11 11.378 15.097 6 23.974 11.521 32.883 17.496 37 23.97 37zm-.003-30c8.043 0 14.965 4.916 20.767 14.748l.355.61.373.664a2 2 0 01-.01 1.957l-.4.694C39.037 35.891 32.01 41 23.966 41c-7.886 0-14.78-4.913-20.677-14.74l-.285-.48a49.45 49.45 0 01-.354-.615l-.108-.19a2 2 0 01-.01-1.948l.337-.607.18-.316C8.856 12.034 15.829 7 23.967 7zM24 16a8 8 0 100 16 8 8 0 000-16zm0 4a4 4 0 110 8 4 4 0 010-8z"/></svg>
</template>
<script>

export default {
  name: 'IconEye',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
